export default "__VITE_ASSET__267ad995__"